import script from "./AlunosAniversariantes.vue?vue&type=script&setup=true&lang=js"
export * from "./AlunosAniversariantes.vue?vue&type=script&setup=true&lang=js"

import "./AlunosAniversariantes.vue?vue&type=style&index=0&id=6bdd83c6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bdd83c6"]])

export default __exports__